var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon--contact",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require("@/render/assets/images/home/icon_service.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }